import { useApi } from "../../api/hooks/use-api.ts";
import { ApiMethod } from "../../api/types.ts";
import { withArrayPayload, withObjectPayload } from "../../api/payload.ts";

export const useClientAccountApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is the account array. Error: payload is the error object.
    const getClientAccounts = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=clientAccounts');

        return response.then(withArrayPayload);
    };

    // A non-JSON body (e.g. a PHP error page) reaches the caller as an empty
    // object, i.e. a failed save, not as a rejected promise.
    const postClientAccount = async (account) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=clientAccount', account);

        return response.then(withObjectPayload);
    };

    const postClientAccountDebitAuthorization = async (account, file) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=clientAccountDebitAuthorization&id=' + account.id, file);

        return response.then(withObjectPayload);
    };

    const updateClientAccount = async (account) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=updateClientAccount&id=' + account.id, account);

        return response.then(withObjectPayload);
    };

    const deleteClientAccount = async (account) => {
        const response = sendProtectedRequest(ApiMethod.DELETE, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=clientAccount&id=' + account.id, account);

        return response.then(withObjectPayload);
    };

    // { payload: <base64>, content_type } of the SEPA mandate template.
    const getClientAccountDebitAuthorizationTemplate = async () => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=clientAccountDebitAuthorizationTemplate');

        return response.then(withObjectPayload);
    };

    return { getClientAccounts, postClientAccount, updateClientAccount, deleteClientAccount, getClientAccountDebitAuthorizationTemplate, postClientAccountDebitAuthorization };
};
